// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 538 ? "recorder" : chunkId) + "-legacy." + {"339":"8eb2db6c","538":"d3555b05"}[chunkId] + ".js";
};